import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propStr, propNumber, propChildren, } from '../../../../helpers/custom-prop-types';
const ProfessionalUnitSectionTitle = (props) => {
    const { count, title, unit } = props;
    return (_jsxs("h3", Object.assign({ className: 'section_title' }, { children: [_jsx("span", Object.assign({ className: 'title_text' }, { children: title })), count > 0 && _jsx("span", Object.assign({ className: 'title_number' }, { children: count })), unit && _jsx("span", Object.assign({ className: 'title_unit' }, { children: unit }))] })));
};
ProfessionalUnitSectionTitle.propTypes = {
    count: propNumber(),
    title: propChildren().isRequired,
    unit: propStr(),
};
ProfessionalUnitSectionTitle.defaultProps = {
    count: undefined,
    unit: undefined,
};
export default ProfessionalUnitSectionTitle;
